import React from "react";
import FaqHypertensionData from "../Components/Common/FaqHypertensionData";

import Banner from "../Utils/Banner";

const FaqHypertension = () => {
  return (
    <>
      <div
        className="bg-gray-200 bg-no-repeat bg-contain "
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <Banner
          title="FAQ's for Hypertension & CVD"
          imageUrl="/assets/Second_Banner.png"
        />

        <div className="mx-auto ml-4 mr-4 md:ml-6 md:mr-6 lg:mr-14 lg:ml-14  xl:ml-32 xl:mr-32 ">
          <FaqHypertensionData />
        </div>
      </div>
    </>
  );
};

export default FaqHypertension;
